<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">配置结算价</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInAddShow && !hideInUserEdit">
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span>
          <label>项目：</label>
          <a-input
            v-model="nameSearch"
            style="width:200px"
            placeholder="请输入项目名称"
          />
        </span>
        <span>
          <a-button @click="onReset" style="margin-right: 10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.project_name }}</td>
              <td>
                <p v-show="item.guard_single_config == 1">自定义配置</p>
                <p v-show="item.guard_single_config == 2">默认配置</p>
              </td>
              <td>
                <span v-for="(element, j) in item.guard_count_type" :key="j">
                  <span v-show="element == 1">{{
                    Number(item.default_order) + "单/天"
                  }}</span>
                  <span v-show="j > 0">&nbsp;|&nbsp;</span>
                  <span v-show="element == 2">{{
                    Number(item.default_hour) + "小时/天"
                  }}</span>
                  <span v-show="j > 2">&nbsp;|&nbsp;</span>
                  <span v-show="element == 3">{{
                    Number(item.guard_base_salary) + "/天"
                  }}</span>
                </span>
              </td>
              <td>
                <span v-for="(element, j) in item.guard_count_type" :key="j">
                  <span v-show="element == 1">{{
                    Number(item.guard_price) + "/单"
                  }}</span>
                  <span v-show="j > 0">&nbsp;|&nbsp;</span>
                  <span v-show="element == 2">{{
                    Number(item.guard_time_price) + "/小时"
                  }}</span>
                  <span v-show="j > 2">&nbsp;|&nbsp;</span>
                  <span v-show="element == 3">{{
                    Number(item.guard_base_salary) + "/月"
                  }}</span>
                </span>
              </td>
              <td>
                <span v-for="(element, k) in item.three_count_type" :key="k">
                  <span v-show="element == 1">{{
                    "服务费:" + Number(item.head_fee)
                  }}</span>
                  <span v-show="k > 0">&nbsp;|&nbsp;</span>
                  <span v-show="element == 2">{{
                    Number(item.three_price) + "/单"
                  }}</span>
                  <span v-show="k > 2">&nbsp;|&nbsp;</span>
                  <span v-show="element == 3">{{
                    Number(item.three_time_price) + "/小时"
                  }}</span>
                </span>
              </td>
              <td class="operation">
                <a @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!--  增加 -->
    <addSetAccount v-on:hideInAdd="hideInAdd" v-if="hideInAddShow" />
    <!--   增加 end -->
    <!-- 编辑 -->
    <setAccountEdit
      v-show="hideInUserEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end-->
  </div>
</template>
<script>
import axios from "axios";
import setAccountEdit from "@/components/manpower/setAccountEdit"; //编辑
import addSetAccount from "@/components/manpower/addSetAccount"; //增加
export default {
  components: {
    setAccountEdit,
    addSetAccount
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      nameSearch: "",
      thList: [
        "项目名称",
        "员工配置",
        "每日计算参数",
        "计薪方式",
        "甲方结算",
        "操作"
      ]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onReset() {
      this.nameSearch = "";
      this.page = 1;
      this.getData();
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = false;
      if (msg) {
        this.reload();
      }
    },
    showInUserList() {
      this.hideInAddShow = false;
      this.hideInUserEdit = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
      // console.log(value);
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Account_config/accountConfigList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.nameSearch,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    retailSystem() {
      let routeUrl = this.$router.resolve({
        path: "/manpower/MonthSettlement"
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
